import { store } from "../store/index";
import {
  synchronizeData,
  filterCenter,
  filterAllCenters,
  allCenters,
} from "../store/actions/CenterActions";

/**
 * Update Farm
 */
export const synchDataFarms = async () => {
  const objSend = {};
  const result = await store.dispatch(synchronizeData("", objSend));
  if (result?.payload?.data) {
    return "OK";
  }
  return null;
};

/**
 * List Centers
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterCenter(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const listFilterAllCenters = async (filter) => {
  const result = await store.dispatch(filterAllCenters(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const listAllCenters = async (filter) => {
  const result = await store.dispatch(allCenters(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List Course
 */
// export const listCenters = async (filter) => {
//   const result = await store.dispatch(getAll(filter));
//   if (result?.payload?.data) {
//     return result.payload.data;
//   }
//   return null;
// };
